import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "c-doer-provide-service-card__item" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "c-doer-provide-service-card__item-label" }, " Описание услуги ", -1)
const _hoisted_3 = { class: "c-doer-provide-service-card__extend-info" }
const _hoisted_4 = {
  key: 0,
  class: "c-doer-provide-service-card__item"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "c-doer-provide-service-card__item-label" }, " Контрагент ", -1)
const _hoisted_6 = { class: "c-doer-provide-service-card__item-value" }
const _hoisted_7 = {
  key: 1,
  class: "c-doer-provide-service-card__item"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "c-doer-provide-service-card__item-label" }, " Скидка ", -1)
const _hoisted_9 = { class: "c-doer-provide-service-card__item-value" }
const _hoisted_10 = { class: "c-doer-provide-service-card__item --align-end" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "c-doer-provide-service-card__item-label" }, " Стоимость услуги ", -1)
const _hoisted_12 = { class: "c-doer-provide-service-card__item-value" }
const _hoisted_13 = { class: "c-doer-provide-service-card__price" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_c_currency = _resolveComponent("c-currency")!
  const _component_collapse_transition = _resolveComponent("collapse-transition")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
    'c-visit-group-provide-service__item': true,
    'c-visit-group-provide-service__item--expanded': _ctx.expanded,
  })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ion_button, {
        class: "c-visit-group-provide-service__spoiler-btn",
        fill: "clear",
        onClick: _ctx.toogleExpand
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_icon, { name: "core-collapse-arrow" })
        ]),
        _: 1
      }, 8, ["onClick"]),
      _hoisted_2,
      _createElementVNode("div", {
        class: "c-doer-provide-service-card__item-value c-visit-group-provide-service__item-value",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toogleExpand && _ctx.toogleExpand(...args)))
      }, _toDisplayString(_ctx.info.nomenclatureName), 1)
    ]),
    _createVNode(_component_collapse_transition, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          (_ctx.info.counterParty)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.info.counterParty), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.info.discountName || _ctx.info.discountPercent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.info.discountPercent) + "% " + _toDisplayString(_ctx.info.discountName), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_c_currency, {
                price: _ctx.info.singleItemPrice
              }, {
                default: _withCtx(({ priceFormatted }) => [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(priceFormatted), 1)
                ]),
                _: 1
              }, 8, ["price"])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.expanded]
        ])
      ]),
      _: 1
    })
  ], 2))
}